import { Component } from '@angular/core';
import { ToastPackage, Toast, ToastrService } from 'ngx-toastr';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent extends Toast {

  constructor(
    protected toastrService: ToastrService,
    public notification: ToastPackage
  ) {
    super(toastrService, notification);
  }

}
